var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('JobLinksGrid',_vm._g(_vm._b({attrs:{"items":_vm.items}},'JobLinksGrid',_vm.$attrs,false),_vm.$listeners)):_c('JobLinksList',_vm._g(_vm._b({attrs:{"items":_vm.items}},'JobLinksList',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }